import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconBack = ({ t, fill, className, height, width }) => (
  <svg
    width={width}
    height={height}
    className={className}
    xmlnsXlink='http://www.w3.org/1999/xlink'
    viewBox='0 0 34 26'
    fill='none'
  >
    <path fill={fill} fillRule='evenodd' clipRule='evenodd' d='M31.6103 15.1293L7.60885 15.1293L14.6693 22.1897C15.4584 22.9788 15.4584 24.26 14.6693 25.0492C13.8787 25.8383 12.5989 25.8383 11.8098 25.0492L1.29695 14.5377C0.507788 13.7472 0.507788 12.4674 1.29695 11.6769L11.8098 1.16543C12.5989 0.37487 13.8787 0.37487 14.6693 1.16543C15.4584 1.9546 15.4584 3.23576 14.6693 4.02492L7.60885 11.0853L31.6103 11.0853C32.7275 11.0853 33.633 11.9908 33.633 13.1066C33.633 14.2238 32.7275 15.1293 31.6103 15.1293Z' />
  </svg>
)

export default Icon(IconBack)
